import { memo, useCallback } from 'react'
import { useGlobalEvent } from '@highlight/ipc/react'
import { SendMessageOptions, useSubmitMessage } from '@renderer/chat'
import { useActivityHandler } from '@renderer/hooks/activity/useActivityHandler.ts'

/**
 * Handle context orchestration in the assistant.
 * Automatically attach things, manage changes in window context, etc.
 */
export const AssistantContextHandler = memo(() => {
  const submitMessage = useSubmitMessage()

  // Handle submitting messages with context.
  const onSubmitMessageEvent = useCallback((input: string | null, options?: SendMessageOptions) => {
    submitMessage(input, options)
  }, [])
  useGlobalEvent('submitMessage', onSubmitMessageEvent)

  // Initialize activity handler
  useActivityHandler()

  return null
})
AssistantContextHandler.displayName = 'AssistantContextHandler'
